// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2RHKC","detailsBorder":"styles_detailsBorder__2k86F"};